import axios from "axios";

import { Audience, AudienceRetention } from "../types/audience";

export interface CreateAudienceData {
  name: string;
  description: string;
  retention: AudienceRetention;
  "fb-ad-account-id": string;
}

export const createAudience = async (
  workspaceSlug: string,
  data: CreateAudienceData,
): Promise<Audience> => {
  return (
    await axios.post(`/api/v1/workspaces/${workspaceSlug}/audiences`, data)
  ).data;
};

export const getAudiences = async (
  workspaceSlug: string,
): Promise<{ total: number; audiences: Audience[] }> => {
  return (await axios.get(`/api/v1/workspaces/${workspaceSlug}/audiences`))
    .data;
};

export const getAudience = async (
  workspaceSlug: string,
  id: number,
): Promise<Audience> => {
  return (
    await axios.get(`/api/v1/workspaces/${workspaceSlug}/audiences/${id}`)
  ).data;
};

export const updateAudience = async (
  workspaceSlug: string,
  audience: Audience,
): Promise<Audience> => {
  return (
    await axios.put(
      `/api/v1/workspaces/${workspaceSlug}/audiences/${audience.id}`,
      audience,
    )
  ).data;
};

export const deleteAudience = async (
  workspaceSlug: string,
  id: number,
): Promise<void> => {
  await axios.delete(`/api/v1/workspaces/${workspaceSlug}/audiences/${id}`);
};
